/** Check if user status represents an active (non-blocked) user */
export const isActive = (status?: string): boolean => status?.toLowerCase() === 'active';
